export const walletProviderTypes = {
    showModal: '[WalletProvider] shows the wallet provider modal',
    setProvider: '[WalletProvider] sets the wallet provider data',
    setAddress: '[WalletProvider] sets the wallet address',
    setNetworkId: '[WalletProvider] sets the provider network',
    setDisconnect: '[WalletProvider] disconnects the network provider'    
}